// Fragment "plan capabilities" — PlanFeatureMatrix.jsx (super-admin) and the "Plan
// features" nav link. Merged by ./index.js. Keys prefixed "pfm." are unique to that
// screen; "nav.planFeatures" sits alongside the rest of SuperAdminLayout.jsx's nav.* keys
// (defined in base.js) but lives here because it ships with this feature, not a retrofit
// of the base file.
export default {
  fr: {
    "nav.planFeatures": "Fonctionnalités des forfaits",
    "plans.manageFeatures": "Gérer les fonctionnalités",

    "pfm.title": "Matrice des fonctionnalités",
    "pfm.subtitle": "Chaque capacité produit, mappée à ce que chaque forfait accorde aux nouveaux abonnés.",
    "pfm.capabilityHeader": "Capacité",
    "pfm.loadError": "Impossible de charger le catalogue de capacités.",
    "pfm.saveOk": "Capacités des forfaits mises à jour.",
    "pfm.save": "Enregistrer les changements",
    "pfm.dirtyCount": "{count} changement(s) non enregistré(s)",
    "pfm.comingSoonBadge": "À venir",
    "pfm.unlimited": "Illimité",
    "pfm.coreIncluded": "Inclus dans chaque forfait",
    "pfm.grandfatherBanner": "Les modifications s'appliquent aux nouvelles inscriptions et aux changements de forfait. Les abonnés existants conservent ce qu'ils ont acheté — ajustez un cabinet depuis Cabinets.",
    "pfm.limitPlaceholder": "Illimité",
    "pfm.limitInputHint": "Nombre entier ; laissez vide pour illimité.",
    "pfm.limitInvalid": "Saisissez un nombre entier positif, ou laissez vide pour illimité.",
    "pfm.goToPlans": "Ouvrir Forfaits",
    "pfm.customAdd": "Ajouter une capacité personnalisée",
    "pfm.customEdit": "Modifier",
    "pfm.customCreateTitle": "Nouvelle capacité personnalisée",
    "pfm.customEditTitle": "Modifier la capacité personnalisée",
    "pfm.customSubtitle": "Les capacités personnalisées sont des lignes marketing uniquement — elles ne peuvent jamais contrôler le code.",
    "pfm.customKey": "Clé",
    "pfm.customKeyHelp": "minuscules, séparées par un point — ex. care.group_sessions",
    "pfm.customKeyInvalid": "La clé doit correspondre à ^[a-z][a-z0-9_]+\\.[a-z][a-z0-9_]+$",
    "pfm.customLabel": "Libellé (EN)",
    "pfm.customLabelFr": "Libellé (FR)",
    "pfm.customLabelEs": "Libellé (ES)",
    "pfm.customGroup": "Groupe",
    "pfm.customStatus": "Statut",
    "pfm.customStatusLive": "En ligne",
    "pfm.customStatusComingSoon": "À venir",
    "pfm.customEta": "Échéance (ETA)",
    "pfm.customEtaHelp": "Facultatif : laissez vide si aucune date n'est annoncée",
    "pfm.customOrder": "Ordre",
    "pfm.customSubmit": "Enregistrer la capacité",
    "pfm.customDelete": "Supprimer",
    "pfm.customCancel": "Annuler",
    "pfm.customCreated": "Capacité personnalisée créée.",
    "pfm.customUpdated": "Capacité personnalisée mise à jour.",
    "pfm.customDeleted": "Capacité personnalisée supprimée.",
    "pfm.customDeleteConfirm": "Supprimer la capacité « {key} » ? Cette action est irréversible.",
    "pfm.labelRequired": "Le libellé est requis.",
    "pfm.groupRequired": "Choisissez un groupe.",
    "pfm.orderInvalid": "L'ordre doit être un nombre entier.",
    "pfm.unknownCapabilityError": "Clé(s) de capacité inconnue(s) : {keys}",
    "pfm.capabilityInUse": "Encore accordée par : {plans}. Retirez-la de ces forfaits d'abord.",
    "pfm.capabilityExists": "Une capacité avec la clé « {key} » existe déjà.",
    "pfm.codeOwnedError": "Ces champs appartiennent au code et ne peuvent pas être modifiés ici : {fields}",
    "pfm.genericError": "Une erreur est survenue.",
  },
  en: {
    "nav.planFeatures": "Plan features",
    "plans.manageFeatures": "Manage features",

    "pfm.title": "Plan feature matrix",
    "pfm.subtitle": "Every product capability, mapped to what each plan grants to new subscribers.",
    "pfm.capabilityHeader": "Capability",
    "pfm.loadError": "Could not load the capability catalogue.",
    "pfm.saveOk": "Plan capabilities updated.",
    "pfm.save": "Save changes",
    "pfm.dirtyCount": "{count} unsaved change(s)",
    "pfm.comingSoonBadge": "Coming soon",
    "pfm.unlimited": "Unlimited",
    "pfm.coreIncluded": "Included in every plan",
    "pfm.grandfatherBanner": "Changes apply to new sign-ups and plan changes. Existing subscribers keep what they bought — adjust one practice from Tenants.",
    "pfm.limitPlaceholder": "Unlimited",
    "pfm.limitInputHint": "Whole number; leave blank for unlimited.",
    "pfm.limitInvalid": "Enter a whole number of zero or more, or leave blank for unlimited.",
    "pfm.goToPlans": "Open Plans",
    "pfm.customAdd": "Add custom capability",
    "pfm.customEdit": "Edit",
    "pfm.customCreateTitle": "New custom capability",
    "pfm.customEditTitle": "Edit custom capability",
    "pfm.customSubtitle": "Custom capabilities are marketing rows only — they can never gate code.",
    "pfm.customKey": "Key",
    "pfm.customKeyHelp": "lowercase, dot-separated — e.g. care.group_sessions",
    "pfm.customKeyInvalid": "Key must match ^[a-z][a-z0-9_]+\\.[a-z][a-z0-9_]+$",
    "pfm.customLabel": "Label (EN)",
    "pfm.customLabelFr": "Label (FR)",
    "pfm.customLabelEs": "Label (ES)",
    "pfm.customGroup": "Group",
    "pfm.customStatus": "Status",
    "pfm.customStatusLive": "Live",
    "pfm.customStatusComingSoon": "Coming soon",
    "pfm.customEta": "ETA",
    "pfm.customEtaHelp": "Optional: leave empty when no date is announced",
    "pfm.customOrder": "Order",
    "pfm.customSubmit": "Save capability",
    "pfm.customDelete": "Delete",
    "pfm.customCancel": "Cancel",
    "pfm.customCreated": "Custom capability created.",
    "pfm.customUpdated": "Custom capability updated.",
    "pfm.customDeleted": "Custom capability deleted.",
    "pfm.customDeleteConfirm": "Delete capability \"{key}\"? This cannot be undone.",
    "pfm.labelRequired": "Label is required.",
    "pfm.groupRequired": "Choose a group.",
    "pfm.orderInvalid": "Order must be a whole number.",
    "pfm.unknownCapabilityError": "Unknown capability key(s): {keys}",
    "pfm.capabilityInUse": "Still granted by: {plans}. Remove it from those plans first.",
    "pfm.capabilityExists": "A capability with key \"{key}\" already exists.",
    "pfm.codeOwnedError": "These fields are code-owned and cannot be edited here: {fields}",
    "pfm.genericError": "Something went wrong.",
  },
  es: {
    "nav.planFeatures": "Funciones de los planes",
    "plans.manageFeatures": "Gestionar funciones",

    "pfm.title": "Matriz de funciones de los planes",
    "pfm.subtitle": "Cada capacidad del producto, asignada a lo que cada plan concede a los nuevos suscriptores.",
    "pfm.capabilityHeader": "Capacidad",
    "pfm.loadError": "No se pudo cargar el catálogo de capacidades.",
    "pfm.saveOk": "Capacidades de los planes actualizadas.",
    "pfm.save": "Guardar cambios",
    "pfm.dirtyCount": "{count} cambio(s) sin guardar",
    "pfm.comingSoonBadge": "Próximamente",
    "pfm.unlimited": "Ilimitado",
    "pfm.coreIncluded": "Incluido en todos los planes",
    "pfm.grandfatherBanner": "Los cambios se aplican a las nuevas altas y a los cambios de plan. Los suscriptores actuales conservan lo que compraron — ajusta una consulta desde Consultas.",
    "pfm.limitPlaceholder": "Ilimitado",
    "pfm.limitInputHint": "Número entero; déjalo vacío para ilimitado.",
    "pfm.limitInvalid": "Introduce un número entero de cero o más, o déjalo vacío para ilimitado.",
    "pfm.goToPlans": "Abrir Planes",
    "pfm.customAdd": "Añadir capacidad personalizada",
    "pfm.customEdit": "Editar",
    "pfm.customCreateTitle": "Nueva capacidad personalizada",
    "pfm.customEditTitle": "Editar capacidad personalizada",
    "pfm.customSubtitle": "Las capacidades personalizadas son solo filas de marketing — nunca pueden controlar el código.",
    "pfm.customKey": "Clave",
    "pfm.customKeyHelp": "minúsculas, separadas por un punto — ej. care.group_sessions",
    "pfm.customKeyInvalid": "La clave debe coincidir con ^[a-z][a-z0-9_]+\\.[a-z][a-z0-9_]+$",
    "pfm.customLabel": "Etiqueta (EN)",
    "pfm.customLabelFr": "Etiqueta (FR)",
    "pfm.customLabelEs": "Etiqueta (ES)",
    "pfm.customGroup": "Grupo",
    "pfm.customStatus": "Estado",
    "pfm.customStatusLive": "En vivo",
    "pfm.customStatusComingSoon": "Próximamente",
    "pfm.customEta": "ETA",
    "pfm.customEtaHelp": "Opcional: déjalo vacío si no hay fecha anunciada",
    "pfm.customOrder": "Orden",
    "pfm.customSubmit": "Guardar capacidad",
    "pfm.customDelete": "Eliminar",
    "pfm.customCancel": "Cancelar",
    "pfm.customCreated": "Capacidad personalizada creada.",
    "pfm.customUpdated": "Capacidad personalizada actualizada.",
    "pfm.customDeleted": "Capacidad personalizada eliminada.",
    "pfm.customDeleteConfirm": "¿Eliminar la capacidad «{key}»? Esta acción no se puede deshacer.",
    "pfm.labelRequired": "La etiqueta es obligatoria.",
    "pfm.groupRequired": "Elige un grupo.",
    "pfm.orderInvalid": "El orden debe ser un número entero.",
    "pfm.unknownCapabilityError": "Clave(s) de capacidad desconocida(s): {keys}",
    "pfm.capabilityInUse": "Todavía concedida por: {plans}. Quítala primero de esos planes.",
    "pfm.capabilityExists": "Ya existe una capacidad con la clave «{key}».",
    "pfm.codeOwnedError": "Estos campos pertenecen al código y no se pueden editar aquí: {fields}",
    "pfm.genericError": "Algo salió mal.",
  },
};
